/**
 * policy-hub.js
 *
 * Ports reference/page-policies.html's own live client-side search
 * (script lines 427-449) essentially verbatim: typing in the search
 * field toggles a `.hide` class on non-matching `.p-card` elements by
 * testing each card's `data-k` keyword attribute plus its own visible
 * text, and reveals the no-results state when zero cards match. Pure
 * local DOM filtering — no network request, no external search
 * service, no dependency, works with Hebrew (String.indexOf is not
 * locale-sensitive, matching the reference's own approach exactly).
 *
 * Adapted from the reference's bare `getElementById('q')`/`'nores'`
 * lookups to the project's own established data-attribute-hook
 * convention (`data-policy-search`/`data-policy-list`/`data-policy-
 * noresults`, all scoped within one `[data-policy-hub]` root) and the
 * same `initX(root)` / `dataset.mvcHomeBound`-style bound-once guard
 * already used throughout homepage.js, so a Theme Editor `shopify:
 * section:load` re-render can never double-bind the listener. This
 * file is loaded only on the Policy Hub page template (`template ==
 * 'page.policies'`, layout/theme.liquid) — never globally, and has no
 * dependency on homepage.js/homepage.css.
 */
(function () {
  'use strict';

  function initPolicySearch(root) {
    var input = root.querySelector('[data-policy-search]');
    if (!input || input.dataset.mvcBound) return;
    input.dataset.mvcBound = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.p-card'));
    var none = root.querySelector('[data-policy-noresults]');
    if (!cards.length) return;

    input.addEventListener('input', function () {
      var term = input.value.trim();
      var found = 0;

      cards.forEach(function (card) {
        if (!term) {
          card.classList.remove('hide');
          found++;
          return;
        }
        var haystack = (card.dataset.k || '') + ' ' + card.textContent;
        var match = haystack.indexOf(term) !== -1;
        card.classList.toggle('hide', !match);
        if (match) found++;
      });

      if (none) none.classList.toggle('on', found === 0);
    });
  }

  function init() {
    document.querySelectorAll('[data-policy-hub]').forEach(initPolicySearch);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
